
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { useFetchData } from "../../../../hooks/useFtechData";
import { JOBSEEKER_URL } from "../../../../resources/resource";
import JobSeekerNotification from "../../JobSeekerNotifications";


const Notifications = () => {
      const dispatch = useDispatch();
      
      const { currentUser, token } = useSelector((state) => state.user);
      const loggedInUser = useSelector((state) => state.user);
      
      const { data: userDetails, refetch: refetchUser } = useFetchData(
        JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
      );
      const userId = localStorage.getItem('userId');
      console.log(userId);
  return (
    <div>
    <div  className="bg-white rounded-lg shadow-sm p-6 mb-8">
            <JobSeekerNotification jobSeeker={userDetails} />
    </div>
      
    </div>
  )
}

export default Notifications
